import setPathMatrix from "../../../actions/length/set-path-matrix";
import getTransformedPoint from "./get-transformed-point";
import setPointRotation from "./set-point-rotation";
import setPointX from "./set-point-x";
import setPointY from "./set-point-y";

/**
 * Compute position for "translate-along-path" (offset-path)
 * @param {MainClassProps} main
 * @param {PropertyValueProps} property
 * @param {String} name
 * @param {PropertyPureProps} value
 * @param {Number} progress
 */
const getOffsetPath = (main, property, name, value, progress) => {
  const offset = main.SVGOffset;
  const path = /** @type {SVGGeometryElement} */ (offset.path);

  if (!path) {
    return;
  }

  value.set("progress", 1);

  const computed = offset.computed;
  const lastX = property.get("last-point-x");
  const lastY = property.get("last-point-y");
  const oriented = property.get("o_oriented");
  const bounds = /** @type {BoundsProps} */ (main.bounds);

  if (computed.x && computed.x !== lastX) {
    const parent = /** @type {SVGSVGElement} */ (offset.parent);

    offset.matrix = setPathMatrix(parent, main);
    property.set("last-point-x", computed.x);
  }

  if (computed.y && computed.y !== lastY) {
    property.set("last-point-y", computed.y);
  }

  if (name === "translateX") {
    setPointX(value, offset, bounds, path, progress);

    return;
  }

  if (name === "translateY") {
    setPointY(value, offset, bounds);

    return;
  }

  if (oriented && name === "rotate") {
    setPointRotation(value, offset, lastX, lastY, value);
  }

  if (!offset.initialized && (!oriented || offset.rotation)) {
    offset.initialized = true;
    main.element.classList.remove("tor-hidden");
  }
};

export default getOffsetPath;
